import React from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import "./NftCompleteList.scss";

function NftCompleteList() {
  return (
    <>
      <Header />
      <div className="exploreCollections nft-list-page">
        <div className="container">
          <div className="section-title">
            <h2>COMPLETE LISTING</h2>
          </div>
          <div className="nft-list-page__left">
            <div className="nft-list-page__img">
              <img src="../images/nft-details.jpg" alt="profileimage" />
            </div>
            <div className="nft-list-page__info-bid">
              <a href="/" className="btn-preview">
                <i className="material-icons-outlined">visibility_outlined</i>{" "}
                Preview
              </a>
            </div>
          </div>
          <div className="nft-list-page__right">
            <div className="nft-list-page__right-aside">
              <div className="nft-list-page__info-bid">
                <h3>#3368</h3>
                <span>Untitled Collection</span>
                <div className="price">
                  <img src="../images/eth.png" alt="eth" /> 88.069{" "}
                  <small>($176,986.10)</small>
                </div>
                <span>Quantity: 1</span>
              </div>
            </div>

            <h6>Confirm listing</h6>
            <p>
              You’ll be asked to review and confirm this listing from your
              wallet.
            </p>

            <div className="button btn-waiting">Waiting for approval ...</div>
            <a href="/" className="button">
              View Listing
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default NftCompleteList;
